import { render, staticRenderFns } from "./ShopsSlider.vue?vue&type=template&id=1daf76b5&scoped=true&"
import script from "./ShopsSlider.vue?vue&type=script&lang=js&"
export * from "./ShopsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ShopsSlider.vue?vue&type=style&index=0&id=1daf76b5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf76b5",
  null
  
)

export default component.exports